import React, { useState } from "react";

import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import CloseIcon from "@mui/icons-material/Close";
import { Btn } from "../../AbstractElements";

const NextIncrOverDueModal = (props) => {
  
  return (
    <div>
      <Dialog open={props.isOpen} onClose={props.handleClose}>
        <DialogTitle>Alert Message!</DialogTitle>
        <DialogContent>
          <Typography>
            {props.msg}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Btn attrBtn={{color:"primary", onClick:props.handleClose}}>
            OK
          </Btn>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default NextIncrOverDueModal;
